export const legal_it_Translation = {
  terms_and_conditions: {
    title: "Termini e Condizioni",
    intro:
      "Questo Contratto di Licenza per l'Utente Finale è un accordo valido tra Te e la Società. Ti preghiamo di leggere attentamente questo EULA. Le regole dell'EULA sono vincolanti per Te. Se non accetti di essere vincolato dalle regole dell'EULA, non utilizzare il WebApp. Se continui a utilizzare il WebApp, ciò significherà che hai letto e compreso l'EULA e accetti di esserne vincolato.",
    definitions: {
      title: "1. DEFINIZIONI E TERMINI",
      description:
        "Per comprendere chiaramente le regole dell'EULA, devi familiarizzare con il significato dei termini utilizzati nell'EULA. In questo EULA i seguenti termini, quando sono scritti in maiuscolo, avranno i seguenti significati:",
      definitions_list: {
        account:
          "« Account » – significa un account personale di un utente dei servizi della Piattaforma, fornito dall'Amministratore della Piattaforma ai sensi dei Termini di Utilizzo della Piattaforma o di un documento simile. L'Account è accessibile con un ID di Piattaforma (nome dell'account) e una password.",
        company:
          "« Società », « Noi » – significa WEBFY, una società incorporata in Irlanda al seguente indirizzo: Black Church. St Mary’s Place. Dublino D07 P4AX. Irlanda.",
        content:
          "« Contenuto » – significa tutti i tipi di contenuto, inclusi, tra l'altro, dati, testi, immagini, video, suoni, collegamenti, software e altre informazioni in qualsiasi forma, messi a tua disposizione tramite il WebApp.",
        device:
          "« Dispositivo » – significa uno smartphone, un tablet o un altro dispositivo mobile simile che possiedi o controlli legalmente esclusivamente per il tuo uso personale non commerciale.",
        eula: "« EULA » – significa questo Contratto di Licenza per l'Utente Finale, che è un accordo vincolante tra Te e la Società. L'EULA può incorporare altri documenti, come la Politica sulla Privacy che regolano i rapporti tra Te e Noi riguardo all'uso del WebApp. Se un documento è parte dell'EULA, avrà una chiara indicazione.",
        intellectual_property_rights:
          "« Diritti di Proprietà Intellettuale » – significa, complessivamente, diritti ai sensi di qualsiasi legge sui brevetti, marchi, diritti d'autore e segreti commerciali, e qualsiasi altro diritto di proprietà intellettuale o esclusivo riconosciuto in qualsiasi paese o giurisdizione in tutto il mondo, inclusi, senza limitazione, i diritti morali o simili.",
        subscription:
          "« Abbonamento » – significa un periodo durante il quale utilizzi il WebApp nel suo complesso o alcuni contenuti aggiuntivi a pagamento.",
        user_generated_content:
          "« Contenuto Generato dagli Utenti » – significa qualsiasi forma di Contenuto, inclusi, tra l'altro, dati, testi, immagini, video, suoni, collegamenti, che sono stati pubblicati dagli utenti su piattaforme online, ad esempio, reti sociali (ad es. Instagram, Facebook).",
        you: "« Tu » – significa una persona che utilizza il WebApp.",
      },
    },
    changes_of_eula: {
      title: "2. MODIFICHE ALL'EULA",
      list: {
        changes_intro:
          "Possiamo introdurre modifiche a questo EULA di tanto in tanto. Devi controllare regolarmente l'ultima versione dell'EULA al link disponibile sulla pagina web.",
        changes_effective:
          "Se non accetti i termini dell'EULA aggiornata, non sei autorizzato a utilizzare il WebApp a partire dal giorno in cui l'EULA aggiornata entra in vigore. In questo caso, non devi utilizzare il WebApp e annullare il rinnovo dei tuoi Abbonamenti.",
      },
    },
    device: {
      title: "3. DISPOSITIVO",
      list: {
        use_non_owned_device:
          "Se intendi utilizzare il WebApp su un Dispositivo non di tua proprietà, devi avere il permesso del proprietario per farlo. Sarai responsabile del rispetto di questo EULA, indipendentemente dal fatto che possiedi o meno il Dispositivo.",
        access_to_non_owned_device:
          "Se non possiedi il Dispositivo, puoi utilizzare il WebApp solo tramite il tuo Account.",
        responsibility:
          "Se utilizzi il Dispositivo insieme ad altre persone, assicurati che nessun altro oltre a te possa utilizzare il WebApp dal tuo Account. Tutte le azioni effettuate nel tuo Account sono considerate tue azioni, indipendentemente da chi le esegue effettivamente. Sei completamente responsabile di tutte le azioni effettuate nel tuo Account.",
        removal:
          "Se decidi di vendere o altrimenti disporre del Dispositivo, devi eliminare il WebApp dal Dispositivo.",
      },
    },
    capacity_and_age: {
      title: "4. CAPACITÀ GIURIDICA E ETÀ",
      list: {
        over_16:
          "Il WebApp è progettato per utenti di oltre 16 anni. Se utilizzi il WebApp, confermi di avere almeno 16 anni e di avere piena capacità giuridica per stipulare il Contratto.",
        between_16_18:
          "Se hai tra i 16 e i 18 anni, il tuo genitore, tutore o altro rappresentante di età legale deve verificare e accettare questo EULA per tuo conto. Se utilizzi il WebApp, confermi che il tuo genitore, tutore o altro rappresentante di età legale ha accettato i termini di questo EULA e ti consente di utilizzare il WebApp.",
      },
    },
    intellectual_property: {
      title: "5. PROPRIETÀ INTELLETTUALE",
      list: {
        license_grant_and_webapp_use_terms:
          "Ti concediamo con la presente una licenza non esclusiva, personale, limitata, revocabile e non trasferibile per accedere, scaricare ed eseguire il WebApp solo sul tuo Dispositivo, a condizione che tu accetti di rispettare tutti i termini e le condizioni di questo EULA. Si prega di notare che il WebApp è concesso in licenza, non venduto, a te.",
        intellectual_property_rights_and_reservation_of_rights:
          "La Società o il licenziante della Società è l'unico titolare dei Diritti di Proprietà Intellettuale riguardanti il WebApp. La Società mantiene tutti i diritti, titoli e interessi sul WebApp e si riserva tutti i diritti non espressamente concessi a te in questo EULA.",
        restrictions_on_transferring_rights_to_webapp:
          "Non puoi vendere, rivendere, distribuire, ridistribuire, noleggiare, concedere in locazione, sublicenziare, cedere, copiare o trasferire in altro modo diritti sul WebApp a terzi.",
        restrictions_on_network_distribution_and_access:
          "Non puoi distribuire o rendere il WebApp disponibile su una rete dove potrebbe essere scaricato o utilizzato da più utenti contemporaneamente, tranne quando espressamente autorizzato da noi.",
        prohibitions_on_interfering_with_webapp_functionality:
          "Non puoi utilizzare alcun dispositivo o processo automatico o manuale per interferire con il corretto funzionamento del WebApp. Tuttavia, puoi utilizzare qualsiasi tipo di dispositivo o processo per rimuovere il WebApp dal tuo Dispositivo.",
        prohibitions_on_decompiling_and_reverse_engineering:
          "Non puoi decompilare, disassemblare, fare reverse engineering o creare opere derivate del WebApp o di sue parti. Tutte le modifiche o miglioramenti del WebApp rimangono di proprietà esclusiva della Società.",
        prohibitions_on_unlawful_use_and_malicious_activity:
          "Non puoi utilizzare il WebApp in modo illecito, per scopi illeciti, o in modo incoerente con questo EULA, né agire in modo fraudolento o malevolo, ad esempio, hackerando o inserendo codice malevolo, come virus, o dati dannosi, nel WebApp.",
      },
    },
    subscription_and_trial_period: {
      title: "6. ABBONAMENTO E PERIODO DI PROVA",
      list: {
        subscription_basis_and_fee_variation:
          "Questo WebApp nel suo complesso o una parte di esso (Contenuto aggiuntivo) è fornito su base di abbonamento a pagamento. La tariffa può variare a seconda della durata dell'Abbonamento.",
        automatic_renewal_and_account_charge:
          "L'Abbonamento si rinnoverà automaticamente per lo stesso periodo alla fine dell'Abbonamento al costo del pacchetto scelto. Il tuo Account sarà addebitato per l'Abbonamento rinnovato entro 24 ore dalla fine dell'Abbonamento corrente.",
        cancellation_of_subscription_renewal:
          "Puoi annullare il rinnovo dell'Abbonamento almeno 24 ore prima della fine dell'Abbonamento: in tal caso, il WebApp nel suo complesso o il suo Contenuto aggiuntivo sarà disponibile fino alla fine dell'Abbonamento. Per annullare il rinnovo automatico dell'Abbonamento, modifica le impostazioni dell'abbonamento del tuo Account. Dopo la fine dell'Abbonamento, il WebApp nel suo complesso o il suo Contenuto aggiuntivo sarà disponibile solo se viene acquistato un nuovo Abbonamento.",
        manual_cancellation_required:
          "Il tuo abbonamento non si fermerà automaticamente. Devi annullare il rinnovo automatico del tuo abbonamento per evitare di essere addebitato per il costo del nuovo Abbonamento.",
        free_trial_period_and_auto_conversion:
          "Il WebApp prevede un periodo di prova gratuito di 7 giorni. Puoi utilizzare il WebApp o il suo Contenuto aggiuntivo gratuitamente durante questo periodo. Tieni presente che alla fine del periodo di prova, verrà automaticamente trasformato in un Abbonamento a pagamento per il periodo più breve disponibile e il tuo Account sarà addebitato per il costo di tale Abbonamento, a meno che tu non annulli l'Abbonamento tramite le impostazioni di abbonamento del tuo Account almeno 24 ore prima della fine del periodo di prova gratuito.",
      },
    },
    fees_and_purchase_terms: {
      title: "7. COSTI E CONDIZIONI DI ACQUISTO",
      list: {
        subscription_costs_availability:
          "I costi di tutti gli Abbonamenti sono disponibili sulla pagina Web.",
        payment_processing_by_platform_administrator:
          "Quando acquisti un Abbonamento, l'Amministratore della Piattaforma addebita il tuo Account e raccoglie denaro per nostro conto. Il pagamento è elaborato da un sistema di elaborazione dei pagamenti implementato dall'Amministratore della Piattaforma.",
        no_access_to_payment_information:
          "Si prega di notare che noi non elaboriamo il tuo pagamento né abbiamo accesso alle tue informazioni di pagamento, come, tra l'altro, i dati della tua carta bancaria, il tuo nome o altre informazioni correlate.",
        questions_on_payment_processing:
          "Se hai domande riguardo al processo di pagamento, ti preghiamo di inviare il tuo problema al servizio di supporto utenti dell'Amministratore della Piattaforma.",
        account_charge_timing:
          "Il tuo Account sarà addebitato del costo del nuovo Abbonamento entro 24 ore dalla fine dell'Abbonamento corrente. Se annulli il rinnovo automatico nelle ultime 24 ore dell'Abbonamento, tale annullamento avrà effetto alla fine del nuovo Abbonamento.",
        no_refunds_and_immediate_content_access:
          "Si prega di notare che non effettuano rimborsi. Il contenuto digitale è reso disponibile immediatamente dopo che la tariffa di Abbonamento è stata addebitata sul tuo Account.",
      },
    },
    user_generated_content: {
      title: "8. CONTENUTO GENERATO DAGLI UTENTI",
      list: {
        exposure_to_objectionable_content:
          "Poiché puoi accedere ai post di altri utenti di Instagram, potresti essere esposto a contenuti generati dagli utenti potenzialmente problematici. Tieni presente che la Società non controlla né pre-verifica alcun contenuto generato dagli utenti pubblicato sui social network.",
        modifications_and_censorship:
          "Qualsiasi tipo di modifica o censura da parte della Società riguardo ai contenuti generati dagli utenti può essere considerata una violazione dei diritti umani o dei diritti d'autore e potrebbe potenzialmente indurti in errore.",
        handling_objectionable_content:
          "Se sei stato esposto a contenuti problematici, puoi utilizzare le funzionalità del rispettivo social network per monitorare e eliminare i contenuti generati dagli utenti problematici.",
        company_disclaimer:
          "In nessun caso la Società sarà responsabile per il contenuto generato dagli utenti.",
      },
    },
    disclaimer: {
      title: "9. ESCLUSIONE DI RESPONSABILITÀ",
      list: {
        general_disclaimer_of_warranties:
          "Nella misura massima consentita dalla legge applicabile, noi e i nostri affiliati, funzionari, dipendenti, agenti, partner e concedenti di licenza decliniamo espressamente tutte le garanzie di qualsiasi tipo, espresse o implicite, riguardo all'accuratezza, adeguatezza o completezza delle informazioni contenute nella nostra WebApp o create dai servizi.",
        content_provided_as_is:
          "Il Contenuto nella nostra WebApp viene fornito su base « così com'è », senza alcuna garanzia di commerciabilità o idoneità per uno scopo o uso particolare. Non garantiamo che otterrete un risultato previsto dall'uso della WebApp.",
        no_warranty_on_specifics: {
          title: "Non garantiamo che:",
          a: "la WebApp soddisfi le vostre esigenze;",
          b: "la WebApp sia priva di errori, sicura o ininterrotta;",
          c: "eventuali errori di funzionalità della WebApp saranno corretti;",
          d: "la qualità della WebApp soddisfi le vostre aspettative.",
        },
        limitation_of_liability:
          "Non avremo alcuna responsabilità per errori o omissioni. Non siamo responsabili per danni, diretti o indiretti, speciali o consequenziali, subiti da voi o da altre persone a causa dell'uso della WebApp, anche se eravate stati avvisati della possibilità di tali danni. Nessun consiglio o informazione, sia orale che scritta, ottenuta da noi o dalla nostra WebApp creerà alcuna garanzia non espressamente dichiarata nel CLA. In nessun caso la nostra responsabilità o quella dei nostri affiliati, in base a qualsiasi causa di azione, sia contrattuale, extracontrattuale o altro, supererà la quota pagata da voi per l'accesso alla WebApp. Inoltre, non avremo alcuna responsabilità per ritardi o fallimenti dovuti a circostanze al di fuori del nostro controllo.",
      },
    },
    transfer_of_rights: {
      title: "10. TRASFERIMENTO DEI DIRITTI",
      list: {
        transfer_by_company:
          "Possiamo trasferire i nostri diritti e obblighi ai sensi di questo CLA a qualsiasi altra organizzazione o individuo senza il tuo consenso. Ti informeremo sempre per iscritto se ciò accade e ci assicureremo che il trasferimento non influisca sui tuoi diritti ai sensi del CLA.",
        transfer_by_user:
          "Puoi trasferire i tuoi diritti o obblighi ai sensi di questo CLA a un'altra persona solo se noi acconsentiamo per iscritto.",
      },
    },
    termination_of_rights: {
      title: "11. RISOLUZIONE DEI DIRITTI",
      list: {
        termination_for_breach:
          "Possiamo terminare i tuoi diritti di utilizzo dell'app Web in qualsiasi momento contattandoti se hai violato gravemente le regole di questo CLA. Se quanto hai fatto può essere corretto, ti daremo un'opportunità ragionevole per farlo.",
        actions_upon_termination: {
          title: "Se noi terminiamo i tuoi diritti di utilizzo dell'app Web:",
          a: "Devi fermare tutte le attività autorizzate da questo CLA, compreso l'uso dell'app Web.",
          b: "Devi eliminare o rimuovere l'app Web da tutti i dispositivi e distruggere immediatamente tutte le copie dell'app Web che possiedi e confermare a noi di averlo fatto.",
        },
      },
    },
    miscellaneous: {
      title: "12. VARIE",
      list: {
        separation_of_paragraphs:
          "Ciascuno dei paragrafi di questo CLA opera separatamente. Se un tribunale o un'autorità competente decide che uno di essi è illecito, i paragrafi rimanenti continueranno ad essere in vigore e a produrre effetti.",
        delay_in_enforcement:
          "Anche se ritardiamo l'applicazione di questo CLA, possiamo comunque applicarlo successivamente. Se non insistiamo immediatamente affinché tu faccia qualcosa che sei tenuto a fare ai sensi dei termini di questo CLA, o se ritardiamo il prendere provvedimenti contro di te in relazione alla violazione del CLA, ciò non significa che non devi fare tali cose e non impedirà a noi di prendere provvedimenti contro di te in una data successiva.",
        governing_law:
          "Questo CLA sarà regolato e interpretato secondo le leggi di Dublino, Irlanda, senza considerare le sue disposizioni sui conflitti di legge.",
        dispute_resolution:
          "In caso di controversia, conflitto o differenza tra te e la Società, sarà risolta amichevolmente attraverso negoziazioni. Se tale controversia, conflitto o differenza non può essere risolta amichevolmente attraverso negoziazioni entro un periodo di trenta (30) giorni, sarà risolta dall'Irish Arbitration Association in conformità con le sue Procedure Internazionali Accelerate.",
        number_of_arbitrators: "Il numero di arbitri sarà uno.",
        place_of_arbitrators: "Il luogo dell'arbitrato sarà Dublino, Irlanda.",
        language_of_arbitrators:
          "L'arbitrato si svolgerà e il lodo sarà emesso in inglese.",
        expense:
          "Ciascuna parte (cioè tu e la Società) sosterrà le proprie spese, ma le parti condivideranno equamente le spese del tribunale arbitrale.",
        support:
          "Supporto. Se desideri sapere di più sull'app Web o hai problemi a usarla, ti preghiamo di contattarci a <tag>support@freelanz.app</tag>",
      },
    },
  },
  privacy_policy: {
    title: "Privacy e Politica",
    commitment_title: "Il Nostro Impegno per la Tua Privacy",
    commitment_text:
      "Rispettiamo e proteggiamo la privacy degli utenti della nostra WebApp. Questa Informativa sulla Privacy spiega come raccogliamo e utilizziamo le tue informazioni ed è parte dei nostri Termini di Utilizzo quando utilizzi la nostra WebApp. Utilizzando la nostra WebApp e il servizio fornito tramite la WebApp (“Servizio”), acconsenti alla nostra Informativa sulla Privacy. Se non sei d'accordo, ti preghiamo di non utilizzare la nostra WebApp.",
    info_collection_title: "Quali informazioni raccogliamo?",
    info_collection_text:
      "Se effettui acquisti o sottoscrivi un abbonamento, i nostri fornitori di servizi di fatturazione di terze parti raccoglieranno informazioni come il tuo nome completo, numero di carta di credito e indirizzo di fatturazione. Se ci invii un'email, potremmo utilizzare il tuo indirizzo email per rispondere alla tua email. Informazioni Inviate dal Tuo Dispositivo Mobile. Raccogliamo alcune informazioni che il tuo dispositivo mobile invia quando utilizzi la nostra WebApp, come un identificatore del dispositivo, impostazioni dell'utente e il sistema operativo del tuo dispositivo, nonché informazioni sull'uso dei nostri Servizi. Informazioni sulla Posizione. Quando utilizzi la nostra WebApp, potremmo raccogliere e archiviare informazioni sulla tua posizione convertendo il tuo indirizzo IP in una geo-localizzazione approssimativa o accedendo alle coordinate GPS del tuo dispositivo mobile o alla posizione approssimativa se abiliti i servizi di localizzazione sul tuo dispositivo. Potremmo utilizzare le informazioni sulla posizione per migliorare e personalizzare i nostri Servizi per te. Se non desideri che raccogliamo informazioni sulla posizione, puoi disabilitare questa funzione sul tuo dispositivo mobile.",
    info_storage_title: "Dove archiviamo le tue informazioni?",
    info_storage_text:
      "Le tue informazioni possono essere archiviate nei nostri server o nei server di fornitori di cloud storage di terze parti. I fornitori di storage di terze parti non possono utilizzare le tue informazioni se non come previsto in questa Informativa sulla Privacy.",
    info_usage_title: "Come utilizziamo le tue informazioni?",
    info_usage_text:
      "Le informazioni che raccogliamo da te potrebbero essere utilizzate:",
    info_storage_duration_title:
      "Per quanto tempo conserviamo le tue informazioni?",
    info_storage_duration_text:
      "Intendiamo conservare alcune delle tue informazioni indefinitamente. E riguardo ai link ad altri siti web? Potremmo fornire link o compatibilità con altri siti web. Tuttavia, non siamo responsabili delle pratiche sulla privacy impiegate da quei siti web o delle informazioni o contenuti che contengono.",
    info_protection_title: "Come proteggiamo le tue informazioni?",
    info_protection_text:
      "Utilizziamo procedure fisiche, elettroniche e altre procedure appropriate per salvaguardare e proteggere le informazioni che raccogliamo. Tuttavia, si prega di notare che Internet è un ambiente intrinsecamente insicuro e che gli hacker lavorano costantemente per superare le misure di sicurezza. Pertanto, non possiamo garantire che le tue informazioni non vengano accessate, divulgate, alterate o distrutte, e accetti questo rischio.",
    user_protection_title: "Come puoi proteggere le tue informazioni?",
    user_protection_text:
      "Ti consigliamo di adottare misure per mantenere al sicuro le tue informazioni personali, non condividendole con altri o pubblicandole online.",
    disclosure_title: "Divulghiamo informazioni a terze parti?",
    disclosure_text:
      "Non raccogliamo, vendiamo, scambiamo o trasferiamo in altro modo a terzi le tue Informazioni di Identificazione Personale (PII) per scopi commerciali o di marketing, salvo quanto indicato nel presente documento. Le informazioni personali (e non personali) raccolte attraverso il Sito possono essere condivise con società e organizzazioni che forniscono servizi per nostro conto (ad esempio, società che forniscono servizi di gestione dei dati o altri servizi di supporto come archiviazione dei dati e servizi di hosting web). Potremmo condividere le tue informazioni personali (e non personali) con terze parti per servirti pubblicità pertinenti e promuovere i nostri prodotti, ma non venderemo le tue informazioni personali. Informazioni Divulgate in Connessione con Transazioni Commerciali. Se siamo acquisiti da una terza parte a seguito di una transazione come una fusione, acquisizione o vendita di beni o se i nostri beni vengono acquisiti da una terza parte nel caso in cui cessiamo l'attività o entriamo in fallimento, alcuni o tutti i nostri beni, incluse le tue PII, possono essere divulgati o trasferiti a un acquirente terzo in relazione alla transazione. Informazioni Divulgate per la Nostra Protezione e la Protezione degli Altri. Collaboriamo con autorità governative e forze dell'ordine o parti private per far rispettare e rispettare la legge. Possiamo divulgare qualsiasi informazione su di te ad autorità governative o forze dell'ordine o a parti private come noi, a nostra esclusiva discrezione, riteniamo necessario o appropriato: (i) per rispondere a reclami, processi legali (inclusi i mandati di comparizione); (ii) per proteggere la nostra proprietà, diritti e sicurezza e la proprietà, diritti e sicurezza di una terza parte o del pubblico in generale; e (iii) per interrompere qualsiasi attività che riteniamo illegale, non etica o legalmente perseguibile.",
    not_for_children_title: "Non Destinato ai Minori",
    not_for_children_text:
      "La nostra WebApp e il Servizio non sono destinati ai minori di 16 anni. Non raccogliamo consapevolmente o specificamente informazioni da o su minori di 16 anni.",
    policy_changes_title: "Modifiche alla nostra Informativa sulla Privacy",
    policy_changes_text:
      "Se decidiamo di modificare la nostra Informativa sulla Privacy, pubblicheremo tali modifiche su questa pagina. Potremmo anche, ma non siamo obbligati, inviarti un avviso via email. Ti invitiamo a consultare frequentemente questa informativa sulla privacy per essere informato su come stiamo proteggendo le tue informazioni.",
    contact_title: "Contattaci",
    contact_text:
      "Se hai domande sulla nostra Informativa sulla Privacy, ti preghiamo di contattarci all'indirizzo <tag>support@freelanz.app</tag>",
  },
};

export const screens_it_Translation = {
  common_text: {
    male: "Maschile",
    female: "Femminile",
    terms_and_conditions: "Termini e Condizioni",
    privacy_policy: "Informativa sulla Privacy",
    copy_right: "Copyright ® 2024. Tutti i diritti riservati.",
    continue: "Continua",
    login_text: "ACCEDI",
  },
  landing_page: {
    title: "Corsi AI Personalizzati",
    personalized_freelance_plan: "Crea il tuo percorso verso la libertà",
    start_freelance_business:
      "Avvia un'attività da freelance: <tag/>Diventa il tuo capo",
    launch_successful_business:
      "Lancia oggi stesso il tuo business di successo da freelance",
    select_text: "Seleziona il tuo sesso:",
  },
  career_plan: {
    title: "Piano di libertà professionale in base alla tua età",
    age_18_24: "18-24",
    age_25_34: "25-34",
    age_35_44: "35-44",
    age_45_plus: "45+",
  },
  community: {
    title: "$36.000",
    sub_title: "potrebbe essere l'inizio della tua avventura da freelance",
  },
  goal_selection: {
    question: "Qual è il tuo obiettivo?",
    priority: "Seleziona la tua prima priorità",
    grow_wealth: "Accrescere la ricchezza",
    be_boss: "Essere il proprio capo",
    travel_more: "Viaggiare di più",
    other: "Altro",
  },
  income_source: {
    question: "Qual è la tua attuale fonte di reddito?",
    job: "Lavoro dalle 9 alle 17",
    freelance: "Freelance",
    other: "Altro",
  },
  income_level: {
    question: "Scegli il tuo attuale livello di reddito",
    low: "Basso",
    medium: "Medio",
    high: "Alto",
  },
  financial_situation: {
    question: "Come descriveresti la tua situazione finanziaria?",
    struggling: "Sto lottando per raggiungere i miei obiettivi finanziari",
    stability: "Vorrei avere più stabilità",
    unsure: "Non sono sicuro",
    comfortable: "Sono a mio agio",
    range_30_50k: "$30.000-$50.000",
    range_50_100k: "$50.000-$100.000",
    range_above_100k: "Più di $100.000",
  },
  remote_work: {
    question: "Valuti la flessibilità del lavoro remoto nella tua carriera?",
    yes: "Sì",
    maybe: "Forse",
    no: "No",
  },
  work_family_balance: {
    question: "Hai difficoltà a bilanciare lavoro e tempo per la famiglia?",
    absolutely: "Assolutamente",
    somewhat: "In parte",
    work_life_balance: "Ho un equilibrio tra lavoro e vita",
    prefer_not_to_say: "Preferisco non dire",
  },
  work_situation: {
    question: "Che tipo di situazione lavorativa aspiri ad avere?",
    remote_balance: "Bilancio remoto",
    stable_routine: "Routine stabile",
    exploring_options: "Sto esplorando opzioni",
  },
  travel_while_working: {
    question: "Vorresti poter viaggiare mentre lavori?",
    dream: "È un sogno",
    traveling: "Sto viaggiando",
    sometimes: "A volte",
    not_priority: "Non è una priorità",
  },
  content_writing_knowledge: {
    question: "Valuta la tua conoscenza della scrittura di contenuti",
    upwork_info:
      "Secondo Upwork, un content writer freelance guadagna circa $42.000 all'anno",
    need_more_info: "Ho bisogno di più informazioni",
    know_everything: "So tutto",
  },
  ai_content_creation: {
    question:
      "Sapevi che gli strumenti AI possono rendere la creazione di contenuti ancora più semplice?",
    no_news: "No, è una novità per me",
    curious: "Sono curioso",
    heard_of_it: "Sì, ne ho sentito parlare",
  },
  digital_marketing_knowledge: {
    question: "Valuta la tua conoscenza del marketing digitale",
    upwork_info:
      "Secondo Upwork, un marketer digitale guadagna circa $100.000 all'anno.",
    need_more_info: "Ho bisogno di più informazioni",
    know_everything: "So tutto",
  },
  promote_business_ability: {
    question: "Valuta la tua capacità di promuovere un'attività",
    upwork_info:
      "Il 70% dei freelance trova il proprio lavoro online, e anche tu puoi.",
    need_more_info: "Ho bisogno di più informazioni",
    know_everything: "So tutto",
  },
  ai_promotion_help: {
    question: "Sapevi che gli strumenti AI possono aiutarti con la promozione?",
    no_news: "No, è una novità per me",
    curious: "Sono curioso",
    heard_of_it: "Sì, ne ho sentito parlare",
  },
  job_interests: {
    question: "Scegli i lavori che potrebbero interessarti",
    digital_marketing: "Marketing Digitale",
    smm: "SMM",
    affiliate_marketing: "Affiliate Marketing",
    dropshipping: "Dropshipping",
    content_writing: "Scrittura di Contenuti",
    copywriting: "Copywriting",
    translation: "Traduzione",
    graphic_design: "Design Grafico",
    blogging: "Blogging",
    illustration: "Illustrazione",
    continue: "Continua",
  },
  freelancing_readiness: {
    question: "Valuta la tua prontezza per iniziare il freelancing",
    need_more_info: "Ho bisogno di più informazioni",
    know_everything: "So tutto",
  },
  freelance_platforms: {
    question: "Piattaforme freelance di cui hai sentito parlare",
    freelancer: "Freelancer",
    linkedin: "LinkedIn",
    fiverr: "Fiverr",
    guru: "Guru",
    toptal: "Toptal",
    upwork: "Upwork",
    designhill: "Designhill",
    flexjobs: "Flexjobs",
    behance: "Behance",
    wwr: "WWR",
  },
  summary_screen: {
    title: "Riepilogo del tuo <line/> <tag>profilo di freelancing</tag>",
    readiness_score: "Punteggio di prontezza",
    result_perfect: "Risultato: Perfetto",
    required_score: "Richiesto - 75",
    impressive_score:
      "Punteggio impressionante per avere successo nel freelancing",
    description:
      "I freelancer godono di maggiore flessibilità e potenziale di guadagno, con il 61% di loro che guadagna più rispetto ai lavori tradizionali. Anche tu puoi beneficiare del freelancing.",
    mindset: "MENTALITÀ",
    entrepreneur: "Imprenditore",
    motivation: "MOTIVAZIONE",
    high: "Alto",
    time_for_freelancing: "TEMPO",
    for_freelancing: "Per il freelancing",
    knowledge: "CONOSCENZA",
    beginner: "Principiante",
  },
  special_achievement: {
    question:
      "C'è qualcosa di <tag/> speciale che desideri <tag/> raggiungere?",
    options: {
      buy_house: "Comprare una casa",
      perfect_wedding: "Un matrimonio perfetto",
      vacation: "Vacanza",
      buy_car: "Comprare un'auto nuova",
      retirement: "Pensionamento senza preoccupazioni",
    },
    continue: "Continua",
  },
  time_to_goal: {
    question:
      "Quanto tempo sei disposto a dedicare per raggiungere il tuo obiettivo?",
    options: {
      five_min: "5 min/giorno",
      ten_min: "10 min/giorno",
      fifteen_min: "15 min/giorno",
      twenty_min: "20 min/giorno",
    },
  },
  personal_plan: {
    title: "Il tuo piano personale per libertà professionale",
    based_on_answers:
      "In base alle tue risposte, ci aspettiamo che tu acquisisca le necessarie competenze freelance entro",
    confident_freelancer_by: "Freelancer sicuro entro {{month}}, {{year}}",
    confident: "Sicuro",
    freelancer: "Freelancer",
    beginner: "Principiante",
  },
  designing_plan: {
    title: "Stiamo progettando il tuo piano per la libertà professionale…",
    people_chosen: "70.000+ persone",
    chosen_freelanz_app: "hanno scelto Freelanz.app",
    exploring_financial_freedom: "Esplorare la libertà finanziaria",
    essential_guide: "Guida Essenziale",
    great_discovery: "Grande Scoperta",
  },
  testimonials: {
    sean: {
      name: "Sean",
      text: "FreeLanz offre libertà finanziaria attraverso il lavoro freelance. L'interfaccia semplificata e le opportunità diverse lo rendono una risorsa preziosa per nuovi freelancer come me.",
    },
    angel: {
      name: "Angel",
      text: "Sono entusiasta del mio percorso di apprendimento con FreeLanz, dove una vasta gamma di argomenti freelance viene esplorata nei loro corsi. Il copywriting è il mio preferito.",
    },
    trisha: {
      name: "Trisha",
      text: "FreeLanz mi ha ispirato a perseguire conoscenze in tecnologia e IA, spingendomi a superare la mia ansia e a puntare a grandi traguardi!",
    },
  },
  email_signup: {
    title:
      "Inserisci la tua email per ottenere il tuo piano personale <tag>Libertà Professionale</tag>!",
    privacy_note:
      "Rispettiamo la tua privacy. La tua email può rendere l'esperienza pubblicitaria più rilevante <tag> Politica sulla Privacy </tag>.",
    email_label: "La tua Email",
    email_placeholder: "Inserisci un'email valida",
    success_message: "Ben fatto!",
  },
  login: {
    title: "Accedi",
    description:
      "Inserisci il tuo indirizzo email registrato per accedere all'app",
    email_label: "La tua email",
    email_placeholder: "Inserisci un'email valida",
    login_button: "Accedi",
    no_account: "Non hai un account? <tag>Registrati</tag>",
  },
  career_plan_ready: {
    title: "Il tuo piano di libertà professionale di 4 settimane è pronto!",
    readiness_level: "Il tuo livello di preparazione",
    after_4_weeks: "Dopo 4 settimane",
    now: "Adesso",
    week_labels: {
      week_1: "Settimana 1",
      week_2: "Settimana 2",
      week_3: "Settimana 3",
      week_4: "Settimana 4",
    },
  },
  otp: {
    title: "Inserisci OTP",
    message:
      "Una password usa e getta è stata inviata al tuo <tag/> Email: {{email}}",
    submit_button: "Invia",
    resend_otp: "Invia di nuovo OTP",
  },
  payment: {
    email: "Email",
    email_placeholder: "Inserisci un'email valida",
    card_number: "NUMERO CARTA",
    expires_on: "SCADENZA",
    process_card: "Elabora Carta",
    discount_expires: "Il sconto scade tra",
    try_now: "PROVA ORA",
    min: "Min",
    sec: "Sec",
    now: "Ora",
    goal: "Obiettivo",
    flexibility: "Flessibilità",
    earning_power: "Potere di guadagno",
    limited: "Limitato",
    high: "Alto",
    basic: "Base",
    disclaimer: "Questa non è una garanzia o promessa di risultati.",
    trial_offer: "Prova <tag>FreeLanz 7 giorni per $1</tag>, e avrai:",
    // trial_offer: "Prova <tag>Freelanz 4 settimane</tag> e scoprirai:",
    benefits: {
      ai_tools: "Impara gli strumenti AI che possono aumentare il tuo reddito",
      additional_sources: "Scopri fonti di reddito aggiuntive",
      skills:
        "Acquisisci le competenze di un Freelance Pro e avvia i tuoi guadagni",
      beginner_lessons: "Accesso a lezioni per principianti",
      guidance: "Guida per competenza e successo nel freelancing",
    },
    trial: "Prova Gratuita di 7 Giorni",
    // trial: "PIANO DI 4 SETTIMANE",
    payment_methods: "Carta di Credito <tag>/</tag> Debito",
    guaranteed_checkout: "Pagamento <tag>Garantito</tag> Sicuro",
    what_you_get: "Cosa Ottieni",
    income_know_how: "Know-how sul reddito da freelance",
    lessons: "Lezioni illuminanti, facili e divertenti",
    personal_coach:
      "Chat 24/7 con il tuo coach personale per ottenere tutte le risposte e ridurre gli errori",
    users_love: "Gli utenti amano i nostri piani",
    user_reviews: {
      review_1:
        "Apprezzo sinceramente le lezioni che fornite su vari argomenti. Sono determinato a eccellere in questo campo e ho ottenuto preziose intuizioni. È stata un'esperienza gratificante e ho acquisito una grande quantità di conoscenze.",
      review_2:
        "Devo riconoscere che questo corso è tra i migliori che abbia mai seguito. Offre intuizioni pratiche nel campo del marketing digitale.",
      review_3:
        "Questi corsi sono stati eccezionalmente utili. Non ho mai trovato un'applicazione che fornisca informazioni così complete come Coursiv. La parte straordinaria è che sto continuamente imparando nuove strategie e tattiche per promuovermi online.",
    },
    career_titles: {
      digital_marketing: "Marketing Digitale",
      content_writer: "Scrittore di Contenuti",
      graphic_designer: "Graphic Designer",
    },
    career_info: {
      digital_marketing: "$100.000 all'anno",
      content_writer: "$42.000 all'anno",
      graphic_designer: "$90.000 all'anno",
    },
    no_degree: "Non è necessario essere un professionista",
    no_university_degree: "Non è necessario un diploma universitario",
    work_at_your_pace: "Lavora al tuo ritmo e alle tue condizioni",
    people_often_ask: "Le persone chiedono spesso",
    faqs: {
      career_freedom_plan:
        "Di cosa tratta il Piano di Libertà Professionale e come posso iniziare?",
      commitment_concerns:
        "Sono preoccupato di impegnarmi nel freelancing e poi di abbandonare a metà strada.",
      technical_skills:
        "È possibile imparare il freelancing senza competenze tecniche specializzate?",
    },
    faq_answers: {
      career_freedom_plan:
        "FreeLanz offre a chiunque l'opportunità di esplorare il freelancing fornendo materiali di apprendimento accessibili. Il Piano di Libertà Professionale si concentra sull'insegnamento delle competenze freelance essenziali in un formato facile da usare e gamificato, affrontando concetti complessi in modo comprensibile.",
      commitment_concerns:
        "Comprendiamo le tue preoccupazioni, per questo FreeLanz garantisce un'esperienza adatta ai principianti. Il nostro mentore AI è disponibile per fornire guida durante il tuo percorso, richiedendo uno sforzo minimo da parte tua.",
      technical_skills:
        "Assolutamente! Le nostre risorse di apprendimento sono progettate per semplificare gli argomenti tecnici, rendendoli accessibili a tutti. Sebbene avere una base tecnica possa essere utile, non è un prerequisito per il successo nel freelancing.",
    },
    money_back_guarantee: "Garanzia di Rimborso del 100%",
    guarantee_message:
      "Crediamo che il nostro piano possa funzionare per te e che otterrai risultati in 4 settimane! Siamo persino disposti a restituire i tuoi soldi se non vedi risultati, ma questo dipende principalmente da te. Per favore, controlla la nostra <tag>Politica di Rimborso</tag> per comprendere tutti i requisiti.",
  },
};
